<template>
    <form class="product-order-form" action="" method="post" ref="orderForm">
        <input type="hidden" name="product_type" :value="selectedProductType" />
        <input type="hidden" name="product_id" :value="selectedProduct.id" />
        <input type="hidden" name="option_id" :value="selectedOption.id" />

        <section v-if="selectedProduct.options.length > 1" class="section" ref="formFields" id="orderform">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_voucher_amount') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-2">
                        <div class="row">
                            <div class="col">
                                <div class="form-group mb-2">
                                    <div class="amount-selection">
                                        <div
                                            v-for="option in selectedProduct.options"
                                            :key="option.id"
                                            @click="selectOption(option)"
                                            class="amount-card"
                                            :class="{'selected': selectedOption && selectedOption.id === option.id}">
                                            <span v-if="option.type === 'fixed'">{{ option.amount.toFixed(0) }} €</span>
                                            <span v-else v-t="'giftVoucher.customAmount'"></span>
                                        </div>
                                    </div>
                                    <div class="invalid-feedback">
                                        <span class="d-block" v-for="error in formErrors.amount" :key="error">
                                          {{ error }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" id="value-voucher-custom-amount" v-if="selectedOption.type === 'slider'">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_voucher_custom_amount') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-2">
                        <div class="row">
                            <div class="col">
                                <div class="form-group mb-2">
                                    <span class="custom-amount">{{ selectedAmount.toFixed(2) }} €</span>
                                    <input
                                        type="range"
                                        class="form-control-range"
                                        id="custom-amount"
                                        name="amount"
                                        :min="selectedOption.min_amount"
                                        :max="selectedOption.max_amount"
                                        :step="selectedOption.step_amount"
                                        v-model.number="selectedAmount">

                                    <div class="invalid-feedback">
                                        <span class="d-block" v-for="error in formErrors.amount" :key="error">
                                          {{ error }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" ref="contactDetails">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <h2>{{ $t('shop.selected_contact_details') }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 order-container-col">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="email">
                                                {{ $t('shop.email') }}
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                class="form-control"
                                                id="email"
                                                :placeholder="$t('shop.email_placeholder')"
                                                :class="{ 'is-invalid': formErrors.email }"
                                                required
                                                v-model="customerMail"
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.email" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-if="whatsAppServiceActive" class="col-12">
                                        <div class="row">
                                            <div class="col-4 col-md-3">
                                                <div class="form-group">
                                                    <label for="phone-code">{{ $t('shop.phone_code') }}</label>
                                                    <select
                                                        id="phone-code"
                                                        name="phone_code"
                                                        class="form-control"
                                                        v-model="selectedPhoneCode"
                                                        ref="countryPhoneCode"
                                                        @change="
                                                            saveToSession('phone_code', 'string', selectedPhoneCode)
                                                        "
                                                    >
                                                        <option disabled value="false" selected>
                                                            {{ $t('shop.dropdown_required') }}
                                                        </option>
                                                        <option
                                                            v-for="templateOption in countryCodePhones"
                                                            :key="templateOption.phone_code"
                                                            :value="templateOption.phone_code"
                                                            :data-country="templateOption.country_code"
                                                        >
                                                            {{
                                                                $t('shop.phone_code_option', {
                                                                    code: templateOption.phone_code,
                                                                    country: $t(
                                                                        'country.' + templateOption.country_code
                                                                    ),
                                                                })
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-8 col-md-9">
                                                <div
                                                    class="form-group"
                                                    v-for="templateOption in selectedCountryCodePhones"
                                                    :key="templateOption.phone_code"
                                                >
                                                    <div class="inner" :class="{ 'mb-1': whatsAppServiceActive }">
                                                        <label for="phone">
                                                            {{ $t('shop.phone') }}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="phone"
                                                            class="form-control"
                                                            id="phone"
                                                            :placeholder="templateOption.placeholder"
                                                            :class="{ 'is-invalid': formErrors.phone }"
                                                            v-model="phoneNumber"
                                                            required
                                                        />
                                                        <div class="invalid-feedback">
                                                            <span
                                                                class="d-block"
                                                                v-for="error in formErrors.phone"
                                                                :key="error"
                                                                >{{ error }}</span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row custom-control-switch-row">
                            <div v-if="whatsAppServiceActive" class="col-12">
                                <div class="custom-control custom-switch">
                                    <div class="form-group mb-1">
                                        <input
                                            class="custom-control-input"
                                            name="whatsapp_status"
                                            type="checkbox"
                                            value="1"
                                            id="whatsapp_message"
                                            v-model="selectedWhatsApp"
                                        />
                                        <label
                                            class="custom-control-label font-weight-normal"
                                            for="whatsapp_message"
                                            v-html="
                                                $t('shop.whatsapp_message', {
                                                    price: whatsAppServicePrice.toFixed(2),
                                                })
                                            "
                                        >
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="custom-control custom-switch">
                                            <div class="form-group mb-1">
                                                <input
                                                    class="custom-control-input"
                                                    name="invoice_wanted"
                                                    type="checkbox"
                                                    id="invoice_wanted"
                                                    v-model="invoiceWanted"
                                                />
                                                <label
                                                    class="custom-control-label font-weight-normal"
                                                    for="invoice_wanted"
                                                    v-html="$t('shop.invoice_wanted')"
                                                >
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="invoicePostActive" class="col-12">
                                <div class="custom-control custom-switch">
                                    <!-- :class="{ 'disabled-element': ! invoiceWanted }" -->
                                    <div class="form-group mb-1">
                                        <input
                                            class="custom-control-input"
                                            name="invoice_per_post"
                                            type="checkbox"
                                            value="1"
                                            id="invoice_per_post"
                                            v-model="selectedInvoicePerPost"
                                        />
                                        <label
                                            class="custom-control-label font-weight-normal"
                                            for="invoice_per_post"
                                            v-html="
                                                $t('shop.invoice_per_post', {
                                                    price: invoicePostPrice.toFixed(2),
                                                })
                                            "
                                        >
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div v-if="invoiceWanted" class="row mt-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="first_name">
                                                {{ $t('shop.first_name') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="first_name"
                                                class="form-control"
                                                id="first_name"
                                                :placeholder="$t('shop.first_name_placeholder')"
                                                :class="{ 'is-invalid': formErrors.first_name }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.first_name"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="last_name">
                                                {{ $t('shop.last_name') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="last_name"
                                                class="form-control"
                                                id="last_name"
                                                :placeholder="$t('shop.last_name_placeholder')"
                                                :class="{ 'is-invalid': formErrors.last_name }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.last_name"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="street">
                                                {{ $t('shop.company') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="company"
                                                class="form-control"
                                                id="company"
                                                :placeholder="$t('shop.company_placeholder')"
                                                :class="{ 'is-invalid': formErrors.company }"
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.company"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-8">
                                        <div class="form-group">
                                            <label for="street">
                                                {{ $t('shop.street') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="street"
                                                class="form-control"
                                                id="street"
                                                :placeholder="$t('shop.street_placeholder')"
                                                :class="{ 'is-invalid': formErrors.street }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.street" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="house">
                                                {{ $t('shop.house_number') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="house"
                                                class="form-control"
                                                id="house"
                                                :placeholder="$t('shop.house_number_placeholder')"
                                                :class="{ 'is-invalid': formErrors.house }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.house" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="postcode">
                                                {{ $t('shop.postcode') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="postcode"
                                                class="form-control"
                                                id="postcode"
                                                :placeholder="$t('shop.postcode_placeholder')"
                                                :class="{ 'is-invalid': formErrors.postcode }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.postcode"
                                                    :key="error"
                                                    >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-8">
                                        <div class="form-group">
                                            <label for="city">
                                                {{ $t('shop.city') }}
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                class="form-control"
                                                id="city"
                                                :placeholder="$t('shop.city_placeholder')"
                                                :class="{ 'is-invalid': formErrors.city }"
                                                required
                                            />
                                            <div class="invalid-feedback">
                                                <span class="d-block" v-for="error in formErrors.city" :key="error">{{
                                                    error
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="country">
                                                {{ $t('shop.residence') }}
                                            </label>
                                            <select
                                                name="country"
                                                id="country"
                                                :class="{ 'is-invalid': formErrors.country }"
                                                class="form-control"
                                                required
                                            >
                                                <option disabled value="false" selected>
                                                    {{ $t('shop.residence_required') }}
                                                </option>
                                                <option
                                                    v-for="templateOption in licensePlateTemplates"
                                                    :key="templateOption.country_name"
                                                    :value="templateOption.id"
                                                >
                                                    {{ $t('country.' + templateOption.country_code) }}
                                                </option>
                                            </select>
                                            <div class="invalid-feedback">
                                                <span
                                                    class="d-block"
                                                    v-for="error in formErrors.country"
                                                    :key="error"
                                                >{{ error }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /ROW -->
            </div>
        </section>

        <section class="section pb-0" ref="priceDetails">
            <div>
                <div class="row">
                    <div class="col-md-12 mb-2 route-toll-col">
                        <div class="summary-container bg-light rounded p-3 mt-3 mb-mobile-section">
                            <div class="row vertical-center">
                                <div class="col-md-6 px-5 py-3 mobile-padding">
                                    <div class="w-100 bg-transparent">
                                        <div class="card-body px-0 pt-0">
                                            <h4 class="mb-4 text-primary">{{ $t('shop.order_details') }}</h4>
                                            <div class="my-2">
                                                <b>{{ $t('shop.order_details') }}</b>
                                                <span class="float-right">
                                                  {{ defaultSelectedProduct.name }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 px-5 py-3 mobile-padding">
                                    <div class="w-100 bg-transparent">
                                        <div class="card-body px-0 d-flex flex-column justify-content-center">
                                            <div v-if="detailedPriceDisplay && serviceFee > 0" class="row text-center">
                                                <div
                                                    class="col-12"
                                                    :class="{
                                                        'col-md-4':
                                                            (selectedInvoicePerPost && !selectedWhatsApp) ||
                                                            (selectedWhatsApp && !selectedInvoicePerPost) ||
                                                            (!selectedWhatsApp && !selectedInvoicePerPost),
                                                        'col-md-3': selectedWhatsApp && selectedInvoicePerPost,
                                                    }"
                                                >
                                                    <div class="product-pricing">
                                                        {{ $t('generic.productPrice') }}:
                                                        <div
                                                            class="product-price line-height-32px product-pricing-price"
                                                        >
                                                            {{ orderPrice.toFixed(2) }} €
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-12"
                                                    :class="{
                                                        'col-md-4':
                                                            (selectedInvoicePerPost && !selectedWhatsApp) ||
                                                            (selectedWhatsApp && !selectedInvoicePerPost) ||
                                                            (!selectedWhatsApp && !selectedInvoicePerPost),
                                                        'col-md-3': selectedWhatsApp && selectedInvoicePerPost,
                                                    }"
                                                >
                                                    <div class="service-fee">
                                                        {{ $t('generic.serviceFee') }}:
                                                        <div class="product-price line-height-32px service-fee-price">
                                                            {{ serviceFee.toFixed(2) }} €
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="selectedWhatsApp"
                                                    class="col-12"
                                                    :class="{
                                                        'col-md-4': !selectedInvoicePerPost,
                                                        'col-md-3': selectedInvoicePerPost,
                                                    }"
                                                >
                                                    <div class="whats-app-fee">
                                                        {{ $t('generic.whatsAppFee') }}:
                                                        <div
                                                            class="product-price line-height-32px whats-app-service-fee"
                                                        >
                                                            {{ whatsAppServicePrice.toFixed(2) }} €
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="selectedInvoicePerPost"
                                                    class="col-12"
                                                    :class="{
                                                        'col-md-4': !selectedWhatsApp,
                                                        'col-md-3': selectedWhatsApp,
                                                    }"
                                                >
                                                    <div class="invoice-per-post-fee">
                                                        {{ $t('generic.invoicePerPostFee') }}:
                                                        <div
                                                            class="product-price line-height-32px invoice-per-post-fee"
                                                        >
                                                            {{ invoicePostPrice.toFixed(2) }} €
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-12"
                                                    :class="{
                                                        'col-md-4 mt-0': !selectedWhatsApp && !selectedInvoicePerPost,
                                                    }"
                                                >
                                                    <div class="price-total">
                                                        {{ $t('giftVoucher.price') }}:
                                                        <div class="product-price line-height-32px">
                                                            {{ getOrderPrice(2) }} €
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="price-total w-100 text-center"
                                                v-if="!detailedPriceDisplay || serviceFee <= 0"
                                            >
                                                {{ $t('giftVoucher.price') }}:
                                                <div class="d-flex flex-row justify-content-center align-items-center">
                                                    <div class="product-price line-height-32px">
                                                        {{ getOrderPrice(2) }} €
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-100 bg-transparent">
                                        <div class="card-body px-0 py-0" ref="tosAcceptedContainer">
                                            <div class="row mb-4 align-items-center">
                                                <div class="col-2">
                                                    <input
                                                        type="checkbox"
                                                        class="checkbox"
                                                        :class="tosError ? 'checkbox-error' : ''"
                                                        id="tos_accepted"
                                                        name="tos_accepted"
                                                        v-model="tosAccepted"
                                                    />
                                                </div>
                                                <div class="col-10 text-justify">
                                                    <label
                                                        class="smaller mb-0 text-hyphens"
                                                        for="tos_accepted"
                                                    >
                                                        <span v-html="$t('giftVoucher.expiryOfRightOfWithdrawal')"></span>
                                                    </label>
                                                    <div class="invalid-feedback d-block" v-if="tosError">
                                                        <span class="d-block">{{ $t('shop.pre-order-warning') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-4 align-items-center" v-if="showNewsletterCheckbox">
                                                <div class="col-2">
                                                    <input
                                                        type="checkbox"
                                                        class="checkbox"
                                                        :value="this.customerReceiveNewsletter"
                                                        id="receive_newsletter"
                                                        name="receive_newsletter"
                                                        v-model="receiveNewsletter"
                                                    />
                                                </div>
                                                <div class="col-10 text-justify">
                                                    <label
                                                        class="smaller mb-0 text-hyphens"
                                                        for="receive_newsletter"
                                                    >
                                                        <span v-html="$t('shop.receive-newsletter')"></span>
                                                        <span v-html="$t('shop.adsInfoText')"></span>
                                                        <span
                                                            @click.prevent="showUnsubscribeNewsletterModal();"
                                                            v-html="$t('shop.unsubscribeNewsletterShopBtn')">
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="checkbox-button-container">
                                                        <button
                                                            class="label btn btn-primary btn-block"
                                                            @click="submitForm"
                                                            type="button"
                                                        >
                                                            <span class="h5">{{ $t('shop.order') }}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <PaymentMethods
                            class="payment-method-container same-margin-top offset-mobile-2"
                            :small="true"
                            @payment-method-changed="
                                paymentMethod = $event;
                            "
                            v-if="paymentMethodSelectionAvailable && selectedProduct"
                        ></PaymentMethods>
                    </div>
                </div>
            </div>
        </section>

        <UnsubscribeNewsletterModal
            ref="unsubscribeNewsletterModal"
            :customer-email="this.customerMail"
        />

        <LoadingAnimation
            :visible="(sendingRequest && showLoadingAnimation) || globalLoading"
            :full-page-loader="globalLoading"
        ></LoadingAnimation>
    </form>
</template>

<script>
import UnsubscribeNewsletterModal from './Shop/UnsubscribeNewsletterModal.vue';
import PaymentMethods from './PaymentMethods.vue';
import LoadingAnimation from './LoadingAnimation.vue';

export default {
    components: {UnsubscribeNewsletterModal, PaymentMethods, LoadingAnimation},
    props: [
        'initialSettings',
        'defaultSelectedProduct',
        'defaultSelectedOption',
        'defaultSelectedRides',
        'routeTollProduct',
        'products',
        'datepickerConfig',
        'licensePlateTemplates',
        'countryCodePhones',
        'tollProducts',
        'tollProductsStartPrice',
        'tollOptions',
        'currentDate',
        'orderPrice',
        'selectedCountryDefault',
        'serviceFee',
        'insuranceFee',
        'preFillFromSession',
        'defaultRightOfWithdrawal',
        'autoScrollUpToWidth',
        'emRedirect',
        'emAbo',
        'systemId',
    ],
    data() {
        const defaultSettings = {};
        for (const key in this.initialSettings) {
            defaultSettings[key] = this.initialSettings[key];
        }

        return {
            defaultSettings,
            settings: this.initialSettings,
            selectedProduct: this.defaultSelectedProduct,
            selectedOption: this.defaultSelectedProduct?.options.find(option => option.is_default) ?? this.defaultSelectedProduct?.options.at(0),
            selectedAmount: 0,
            selectedInvoicePerPost: false,
            fullPageLoader: false,
            selectedWhatsApp: false,
            residenceInAustria: false,
            globalLoading: false,
            selectedPhoneCode: 'false',
            phoneNumber: '',
            rightOfWithdrawal: this.defaultRightOfWithdrawal !== null ? '' + this.defaultRightOfWithdrawal : null,
            rightOfWithdrawalClass: {
                'btn-outline-primary': true,
                'btn-primary': false,
            },
            paymentMethodSelectionAvailable: true,
            paymentMethod: null,
            invoiceWanted: false,
            sendingRequest: false,
            showLoadingAnimation: true,
            tosAccepted: false,
            receiveNewsletter: false,
            tosError: false,
            buyNowVisible: false,
            formErrors: {},
            inputKeysChangeStatus: {
                email: false,
                product_id: false,
                option_id: false,
                country_code: false,
                first_name: false,
                last_name: false,
                street: false,
                house: false,
                postcode: false,
                city: false,
            },
            orderValidationCallback: null,
            customerMail: '',
        };
    },
    computed: {
        /**
         * @returns {boolean}
         */
        detailedPriceDisplay() {
            return typeof this.settings['shop.detailed_price_overview'] === 'boolean' && this.settings['shop.detailed_price_overview'];
        },
        /**
         * @returns {boolean}
         */
        showNewsletterCheckbox() {
            return this.settings['shop.enableNewsletterCheckbox'];
        },
        /**
         * @returns {boolean}
         */
        expiryOfRightOfWithdrawalActive() {
            return this.settings['shop.enableExpiryOfRightOfWithdrawal'];
        },
        /**
         * @returns {boolean}
         */
        showExpiryOfRightOfWithdrawal() {
            return this.expiryOfRightOfWithdrawalActive && !(this.residenceInAustria || this.selectedCountry == 'AT');
        },
        /**
         * @returns {boolean}
         */
        licenseRevocationAcceptedValid() {
            return (this.showLicenseRevocationCheckbox && this.licenseRevocationAccepted) || !this.showLicenseRevocationCheckbox;
        },
        /**
         * @returns {boolean}
         */
        whatsAppServiceActive() {
            return typeof this.settings['whatsapp.active'] === 'boolean' && this.settings['whatsapp.active'];
        },
        /**
         * @returns {boolean}
         */
        disableRightOfWithdrawal() {
            return typeof this.settings['registration.delayed.disable'] === 'boolean' && this.settings['registration.delayed.disable'];
        },
        /**
         * @returns {boolean}
         */
        invoicePostActive() {
            return typeof this.settings['invoice_post.active'] === 'boolean' && this.settings['invoice_post.active'];
        },
        /**
         * @returns {number}
         */
        whatsAppServicePrice() {
            return this.settings['whatsapp.price'];
        },
        /**
         * @returns {number}
         */
        invoicePostPrice() {
            return this.settings['invoice_post.price'];
        },

        customerReceiveNewsletter() {
            return this.receiveNewsletter;
        },

        selectedProductType() {
            return this.selectedProduct.productType;
        },
    },

    methods: {
        getOrderPrice(digits) {
            let price = this.orderPrice;

            if (this.selectedOption) {
                price += this.selectedOption.amount;
            }

            if (this.selectedOption.type === 'slider' && this.selectedAmount) {
                price += this.selectedAmount;
            }

            if (this.selectedWhatsApp && this.whatsAppServicePrice > 0) {
                price += this.whatsAppServicePrice;
            }
            if (this.selectedInvoicePerPost && this.invoicePostPrice > 0) {
                price += this.invoicePostPrice;
            }

            if ('number' === typeof digits && !isNaN(digits) && digits >= 0) {
                return price.toFixed(digits);
            }

            return price;
        },

        submitForm() {
            this.tosError = false;

            if (
                this.tosAccepted &&
                null !== this.paymentMethod
            ) {
                this.formErrors = {};

                this.changeSendingRequest(true);
                this.showLoadingAnimation = false;
                this.globalLoading = true;
                this.fullPageLoader = true;

                axios
                    .post('/' + this.$language + '/payment/gift-voucher', new FormData(this.$refs.orderForm))
                    .then((response) => {
                        this.paymentMethodSelectionAvailable = false;
                        this.changeSendingRequest(false);
                        this.showLoadingAnimation = false;

                        if ('string' === typeof response.data.orderUri) {
                            window.location.href = response.data.orderUri;
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 422 && !error.response.data.valid) {
                            this.globalLoading = false;
                            this.fullPageLoader = false;

                            this.formErrors = error.response.data.errors;

                            setTimeout(
                                function () {
                                    const invalidFormField = document.querySelector('.invalid-feedback:not(:empty)');

                                    if (invalidFormField !== null) {
                                        const elementY = invalidFormField.parentElement.getBoundingClientRect().top;
                                        const topNavHeight = document
                                            .querySelector('#topnav')
                                            .getBoundingClientRect().height;
                                        const windowY = window.scrollY;

                                        window.scrollTo(0, windowY + elementY - topNavHeight);
                                    }
                                }.bind(this),
                                10
                            );
                        }
                    })
                    .finally(() => {
                        // This one's always executed, acting like a finally-block for try-catch
                        this.changeSendingRequest(false);
                        this.globalLoading = false;
                        this.fullPageLoader = false;
                    });
            } else {
                if (!this.licenseRevocationAcceptedValid) {
                    this.licenseRevocationError = true;
                }

                if (!this.tosAccepted) {
                    this.tosError = true;
                }

                const elementY = this.$refs.tosAcceptedContainer.getBoundingClientRect().top;
                const topNavHeight = document.querySelector('#topnav').getBoundingClientRect().height;
                const windowY = window.scrollY;

                window.scrollTo(0, windowY + elementY - topNavHeight);
            }
        },

        changeSendingRequest(requesting = false) {
            this.sendingRequest = requesting;
            this.$emit('request-sending-change', requesting);
        },

        selectOption(option) {
            if (option.type === 'slider') {
                this.selectedAmount = option.min_amount;
            }
            this.selectedOption = option;
        },

        /**
         * Handle the product helper modal.
         *
         * @returns {void}
         */
        showUnsubscribeNewsletterModal() {
            this.$refs.unsubscribeNewsletterModal.showModal();
        },
    },

    mounted() {
        if (this.selectedOption.type === 'slider') {
            this.selectedAmount = this.selectedOption.min_amount;
        }

        setTimeout(() => {
            if (window.location.hash === '') return;

            const element = document.querySelector(window.location.hash);
            if (!element) return;

            const rect = element.getBoundingClientRect();

            const yOffset = document.querySelector('#topnav').getBoundingClientRect().height;
            const top = rect.top + window.scrollY - yOffset;

            window.scrollTo({top, behavior: 'instant'});
        }, 50);
    },
};
</script>
<style lang="scss">
.product-order-form {
    position: relative;

    input[type='range'] {
        accent-color: var(--main-color);
    }

    .amount-selection {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 1rem;
    }

    @media (max-width: 992px) {
        .amount-selection {
            grid-template-columns: auto;
        }
    }

    .amount-card {
        padding: 2rem;
        border: 1px solid #d2d2d7;
        border-radius: 1rem;
        text-align: center;
    }

    .amount-card span, .custom-amount {
        font-size: 1.75rem;
        font-family: var(--font);
        padding: 0;
        margin: 0;
    }

    .custom-amount {
        font-size: 2.75rem;
    }

    .amount-card:hover, .amount-card.selected {
        background-color: var(--main-color) !important;
        border: 1px solid var(--main-color);
        color: #fff;
        cursor: pointer;
    }

    .custom-control-switch-row {
        max-width: 470px;
        // margin: 0 auto;
    }

    .disabled-element {
        position: relative;
    }

    .disabled-element:after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 88888;

        cursor: not-allowed;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .same-margin-top {
        margin-top: 20px;
    }

    .payment-method-container,
    .summary-container {
        padding: 0 1.31rem;
    }

    & > .loader-container, .loader-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99999;

        width: 100%;
        height: 100%;

        background-color: rgba(255, 255, 255, 0.4);
    }

    & > .loader-container.full-page-loader {
        position: fixed;
    }

    & > .loader-container #status {
        position: fixed !important;
    }

    #preloader {
        position: absolute;
        background: transparent;
    }

    .product-price {
        font-weight: 700;
        font-size: 30px;
    }

    input[type='checkbox'],
    input[type='radio'] {
        -webkit-transform: scale(1.2, 1.2);
    }

    input[type='text'],
    input[type='email'] {
        color: #161c2d;
    }
}

::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba(0, 0, 0, 0.3);
    opacity: 1; /* Firefox */
}

:-ms-input-placeholder, /* Internet Explorer 10-11 */
::-ms-input-placeholder /* Microsoft Edge */ {
    color: rgba(0, 0, 0, 0.3);
}
</style>
